import React from 'react'
import {useTranslation} from 'react-i18next'
import {useHistory, useLocation} from 'react-router-dom'

import {Box, Typography} from '@mui/material'

import {ReactComponent as ErrorSVG} from '@progyny/assets/images/404-new.svg'
import SubmitButton from '@progyny/components/Buttons/SubmitButton'
import SimpleMessageContainer from '@progyny/components/SimpleMessageContainer'
import {RouteEnum, useRoutes} from '@progyny/routes'

const ErrorPage = () => {
  const {t} = useTranslation()
  const {getPath} = useRoutes()
  const history = useHistory()
  const location = useLocation()
  const routerState = location.state as {errorMessage: string}
  const routerErrorMessage = routerState?.errorMessage

  return (
    <SimpleMessageContainer
      image={ErrorSVG}
      actionArea={
        <SubmitButton onClick={() => history.push(getPath(RouteEnum.HOME))}>
          {t('404_start_page')}
        </SubmitButton>
      }
      message={
        <Box>
          <Typography variant={'h2'} textAlign={'center'}>
            {t(
              'partners_agreement_partner_agreement_error_something_went_wrong'
            )}
          </Typography>
          <Typography variant={'body2'} mt={2} textAlign={'center'}>
            {routerErrorMessage ||
              t(
                'partners_agreement_partner_agreement_error_we_re_working_on_problem'
              )}
          </Typography>
        </Box>
      }
    />
  )
}

export default ErrorPage
